module.exports = __webpack_public_path__ + "static/media/lostOppsStandIn.729bc087.png";